import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { SharedComponentsModule } from "../../../shared/components/shared-components.module";
import { offset } from 'handsontable/helpers/dom';
import moment from 'moment';
import alasql from 'alasql';
import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { MatSnackBar } from '@angular/material/snack-bar';



(alasql as any).utils.isBrowserify = false;
(alasql as any).utils.global.XLSX = XLSX;

@Component({
  selector: 'app-all-documents',
  templateUrl: './all-documents.component.html',
  styleUrls: ['./all-documents.component.css']
})
export class AllDocumentsComponent {
  // supplierData: any[] = [];
  showLoader: boolean = true;
  nextMpsCode: number = 0;
  searchKeyword: string = '';

  limit: number = 10;           // Rows per page
  offset: number = 0;           // Current page offset
  archivedLimit: number = 10;           // Rows per page
  archivedOffset: number = 0;           // Current page offset
  totalRecords: number = 0;     // Total number of records
  archivedTotalRecords: number = 0;
  sortField:string =  'companyName';
  sortDirection: string = 'asc';
  docStatus:any;
  fromDate:any;
  toDate:any;

  documentData:any[]=[]
  archivedDocumentData:any[]=[]
  documentDataTotalRecords:number=0
  isFilterExpand:boolean=false;
  isArchivedExpand: boolean = true;
  searchParam:string = '';
  selectedRfq:number[]=[]
  selectedArchivedRfq:number[]=[]

  columns = [
    { name: "Buyer", prop: "companyName", visible: true },
    { name: "Document Type", prop: "docType", visible: true },
    { name: "Reference", prop: "rfqRefNumber", visible: true },
    { name: "Approved By", prop: "approvedBy", visible: true },
    { name: "Status", prop: "docStatus", visible: true },
    { name: "Date", prop: "rfqDate", visible: true },

    { name: "Quote before date", prop: "quotedByDate", visible: false },
    { name: "Vessel", prop: "vesselName", visible: false },
    { name: "Port Country", prop: "portCountry", visible: false },
    { name: "Port Name", prop: "portName", visible: false },
    { name: "Buyer Contact Name", prop: "contact", visible: false },
    // { name: "Supplier Contact Name", prop: "rfqRefNumber", visible: false },
    // { name: "Total Cost", prop: "approvedBy", visible: false },
    { name: "Delivery date", prop: "requestDeliveryDate", visible: false },
    // { name: "Expiry Date", prop: "rfqDate", visible: false },

  ];

  

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private snack: MatSnackBar,
  ) { }

  async ngOnInit() {

    await this.fetchAllDocuments()
    await this.fetchArchivedAllDocuments()

  }

 
  async fetchAllDocuments(){

    
    let fromDate = this.fromDate ? moment(this.fromDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    let toDate = this.toDate ? moment(this.toDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    

    this.showLoader = true;
    
     const response= await this.SettingsService.fetchAllRfqBySupplierId(this.searchParam, Number(this.cookieService.get('userId')), this.docStatus, fromDate, toDate, this.sortField, this.sortDirection, this.limit, this.offset,1)


    if (response && Array.isArray(response.rows) && typeof response.totalElements === 'number') {
      // Properly set the response data
      this.documentData = response.rows;
      
      this.totalRecords = response.totalElements;

      this.showLoader = false;
      
    } else {
      console.error('Invalid response structure', response);
    }

  }

  async fetchArchivedAllDocuments(){

    
    let fromDate = this.fromDate ? moment(this.fromDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    let toDate = this.toDate ? moment(this.toDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    

    this.showLoader = true;
    
     const response= await this.SettingsService.fetchAllRfqBySupplierId(this.searchParam, Number(this.cookieService.get('userId')), this.docStatus, fromDate, toDate, this.sortField, this.sortDirection, this.archivedLimit, this.archivedOffset,0)


    if (response && Array.isArray(response.rows) && typeof response.totalElements === 'number') {
      // Properly set the response data
      this.archivedDocumentData = response.rows;
      
      this.archivedTotalRecords = response.totalElements;

      this.showLoader = false;
      
    } else {
      console.error('Invalid response structure', response);
    }

  }

// Method to handle page change event from ngx-datatable
onPageChange(event: any) {
  this.offset = event.offset; // Update offset from the page change event
  this.fetchAllDocuments(); // Fetch data with new offset
}

// Method to handle search functionality
onSearch() {
  this.offset = 0; // Reset offset for new search
  this.archivedOffset = 0
  this.fetchAllDocuments();
  this.fetchArchivedAllDocuments()
}

// Handle sort change event from ngx-datatable
onSort(event: any) {
  const sort = event.sorts[0];
  this.sortField = sort.prop;
  this.sortDirection = sort.dir;

  // Apply sorting and fetch data accordingly
  // Note: Sorting in your backend should be implemented to support `sortField` and `sortDirection`
  this.fetchAllDocuments();
}

onArchivedSort(event: any){

}

onArchivedPageChange(event: any) {
  this.archivedOffset = event.offset; // Update offset from the page change event
  this.fetchArchivedAllDocuments(); // Fetch data with new offset
}
  

  async OpenRfq(rfqDetailsId: number, supplierId : number) {
    
    // let data = {
    //   supplierId: supplierId,
    //   rfqId: rfqDetailsId
    // }
    // const pdf = await this.SettingsService.generateSupplierRfqAttachment(data)

    // const uint8Array = new Uint8Array(pdf.data);
    // const blob = new Blob([uint8Array], { type: 'application/pdf' });
    // const url = URL.createObjectURL(blob);
    //  window.open(url);
    const newWindow = window.open('', '_blank'); // Open immediately

  if (!newWindow) {
    alert('Popup blocked. Please allow popups for this site.');
    return;
  }

  let data = {
    supplierId: supplierId,
    rfqId: rfqDetailsId
  };

  try {
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data);
    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    newWindow.location.href = url;
  } catch (error) {
    newWindow.close(); // Cleanup
    console.error('Failed to open RFQ PDF', error);
    alert('Failed to open PDF. Please try again.');
  }

  }

  async downloadRfq(rfqDetailsId:number, supplierId: number, refNo:string){
   
    this.showLoader = true;
    
    let fileName = refNo +'.pdf';
    
    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId
    }
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.showLoader = false;

  }

  OpenSupplierProductPopUp(isNew?: boolean, row?: any, userId?: any) {
      this.router.navigate([
        "dataManagement",
        {
          outlets: {
            "form-outlet": ["product-binding", userId],
          },
        },
      ],{
        state: { supplierId: userId }, // Add your data here
      });
  }



  OpenSupplierPreviewPopup( row?: any, userId?: any, companyId?:any) {
      this.router.navigate([
        // "dataManagement",
        // 'pro',  
        //  userId
        "settings", "profile","about", userId, companyId

      ]);
  }

  OpenSupplierProfilePopup( row?: any, userId?: any, companyId?:any){
    this.router.navigate([
      
      "settings", "supplierProfile", userId, companyId

    ]);
  }

  exportAll(){

    this.showLoader = true;

    let exportData : any[] = []

    this.documentData.forEach((docDetails) => {
      exportData .push({
        "Buyer": docDetails.companyName,
        "Document Type": docDetails.docType,
        "Reference": docDetails.rfqRefNumber,
        // "Approved By": docDetails.approvedBy,
        "Status": docDetails.docStatus,
        "Date": docDetails.rfqDate,
        // "Doc": docDetails.name,
        // "Quote before date": docDetails.name,
        // "Vessel": docDetails.name,
        // "Port Country": docDetails.name,
        // "Port Name": docDetails.name,
        // "Buyer Contact Name": docDetails.name,
        // "Supplier Contact Name": docDetails.name,
        // "Total Cost": docDetails.name,
        // "Delivery date": docDetails.name,
        // "Expiry Date": docDetails.name,
       
      });
    });

    alasql('SELECT * INTO XLSX("RFQ Data",{headers:true}) FROM ?', [exportData ]);

    this.showLoader = false;

  }

  toggleVisibility(){
    this.isFilterExpand  =! this.isFilterExpand
  }

  toggleArchived(){
    this.isArchivedExpand = !this.isArchivedExpand
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find(col => col.prop === prop);
    return column ? column.visible : false;
  }

  search(){}
  cancelFilter(){
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments ();

  }

  toggleColumn(column: any) {
    column.visible = !column.visible;
  }

  toggleSelectAll(event:any, section:string){
    
    const checked = event.target.checked;
    const ids = this.documentData.map(item => item.supplierRfqDetailsId);
 
    if(section == 'active'){
      if(checked){
        this.selectedRfq = this.documentData.map(item => item.supplierRfqDetailsId);
      }
      else{
        this.selectedRfq = []
      }
    }
    else{
      if(checked){
        this.selectedArchivedRfq = this.archivedDocumentData.map(item => item.supplierRfqDetailsId);
      }
      else{
        this.selectedArchivedRfq = []
      }
    }
  
   
  }

  selectDeselectRfq(event:any, supplierRfqDetailsId:any, section:string){
    
    const checked = event.target.checked;

    if(section == 'active'){
      if(checked){
        this.selectedRfq.push(supplierRfqDetailsId)
      }
      else{
        this.selectedRfq = this.selectedRfq.filter(id => id !== supplierRfqDetailsId);
      }
    }
    else{
      if(checked){
        this.selectedArchivedRfq.push(supplierRfqDetailsId)
      }
      else{
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(id => id !== supplierRfqDetailsId);
      }
    }


    
  }

  async rfqOperation(operation:string){

    if(operation == 'unarchive'){
      

      if(this.selectedArchivedRfq.length == 0){
        this.snack.open('Please select atleast one', 'OK', {
          duration: 3000,
        });
        return;
      }

      this.showLoader = true;
      await this.SettingsService.rfqOperations(
        {
          operation:operation,
          selectedRfqId : this.selectedArchivedRfq
        }
      )
      this.showLoader = false;
        this.snack.open('Items unarchived', 'OK', {
          duration: 3000,
        });


    }
    else{

      if(this.selectedRfq.length == 0){
        this.snack.open('Please select atleast one.', 'OK', {
          duration: 3000,
        });
        return;
      }

      let data = {
        operation:operation,
        selectedRfqId : this.selectedRfq
      }
      
      if(operation == 'archive'){
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data)
        this.showLoader = false;
        this.snack.open('Items archived', 'OK', {
          duration: 3000,
        });
      }
      else if(operation == 'markAsOpen'){
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data)
        this.showLoader = false;
        this.snack.open('Items marked as open', 'OK', {
          duration: 3000,
        });
      }
      else if(operation == 'markAsUnopen'){
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data)
        this.showLoader = false;
        this.snack.open('Items marked as unopen', 'OK', {
          duration: 3000,
        });
      }

    }

    this.fetchAllDocuments()
    this.fetchArchivedAllDocuments()
    this.selectedArchivedRfq = []
    this.selectedRfq = []

    
  }

  isChecked(supplierRfqDetailsId:number, section:string){
    if(section == 'active'){
      return this.selectedRfq.includes(supplierRfqDetailsId)
    }
    else{
      return this.selectedArchivedRfq.includes(supplierRfqDetailsId)
    }
   
  }

  openRfqDetails(rfqId:number){
    console.log('asdddf')
    this.router.navigate([
      "/dashboard", 'quote','rfq-details', rfqId
      ]
      );
  }

  


}
